import { render } from "./ProductsOffered.vue?vue&type=template&id=755f7084"
import script from "./ProductsOffered.vue?vue&type=script&lang=js"
export * from "./ProductsOffered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__